// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useEffect, useRef, useState } from "../00-boot.jsx";
import { lanacSupabaseClient, lanacWrite } from "../08-supabase-client.jsx";
// ── Tranche 2 · useNav : vue courante & historiques de navigation ───────────
//    view (+miroir viewRef lu par les effets realtime sans re-abonnement),
//    pile mobile, retour détail, historique de consultation.
//    Les 3 effets nav restants (deep-link SW, scroll, pull-to-refresh) restent
//    dans App() : ils appellent des fonctions d'App (openNoticeTarget,
//    attachPullToRefresh) — ils suivront leur tranche propriétaire.
function useNav(me){
  const [view,setView]=useState("home");
  const viewRef=useRef("home");
  useEffect(()=>{viewRef.current=view;},[view]);
  // (mobileHistory : pile de l'ancien retour mobile pré-routeur d'URL — supprimée le 16/07/2026,
  //  prouvée écrite-jamais-lue après le retrait du repli inatteignable de mobileBack.)
  // (detailBackView : « vue de retour » de l'ancienne fermeture de fiche (closeMarketDetail) — supprimé
  //  le 17/07/2026, prouvé écrit-jamais-lu depuis que le routeur d'URL restaure l'écran via popstate.)
  const [viewedHistory,setViewedHistory]=useState([]);
  // V3-T3a : « Vu récemment » — cache local instantané puis source de vérité Supabase.
  useEffect(()=>{
    if(!me){setViewedHistory([]);return;}
    // 1) cache local instantané (offline-friendly)
    let local=[]; try{local=JSON.parse(localStorage.getItem(`lanac:viewed:${me.id}`)||"[]");}catch{local=[];}
    setViewedHistory(Array.isArray(local)?local:[]);
    // 2) source de vérité Supabase (synchro multi-appareils) ; repli silencieux sur le cache local
    (async()=>{
      try{
        const _c=lanacSupabaseClient(); if(!_c) return;
        const {data,error}=await _c.from("recently_viewed").select("listing_id,ts").eq("user_id",me.id).order("ts",{ascending:false}).limit(20);
        if(error||!Array.isArray(data)) return;
        const server=data.map(r=>({id:r.listing_id,ts:Number(r.ts)||0}));
        // migration douce : pousse vers le serveur les vues locales encore absentes (best-effort, UNE fois par compte et par
        //  appareil). ⚠️ (04/10, vu par l'e2e S132 — S5 : 44 erreurs) elle se rejouait à CHAQUE démarrage : la vue d'une
        //  annonce SUPPRIMÉE depuis (sa ligne part en cascade) revenait « absente », son upsert violait la clé étrangère (409) et
        //  faisait échouer tout le lot — une requête ratée et une erreur à chaque ouverture de l'app. Faite, le serveur fait foi.
        const _cleSync=`lanac:viewedSync:${me.id}`;
        let _faite=false; try{_faite=localStorage.getItem(_cleSync)==="1";}catch{}
        const serverIds=new Set(server.map(x=>x.id));
        const missing=_faite?[]:(Array.isArray(local)?local:[]).filter(x=>x&&x.id!=null&&!serverIds.has(x.id));
        //  (30/10/2026, lot D · la sentinelle) par lanacWrite : un refus se DIT ; un 23503 (une annonce supprimée depuis) est dit UNE fois par
        //   appareil (la reprise ne se rejoue pas) ; une coupure reste muette.
        if(missing.length) lanacWrite({what:"vus récemment (reprise de l'appareil)",table:"recently_viewed",op:"upsert",values:missing.map(x=>({user_id:me.id,listing_id:x.id,ts:Number(x.ts)||Date.now()})),onConflict:"user_id,listing_id",columns:"listing_id",expect:"any",quiet:["offline"]});
        try{localStorage.setItem(_cleSync,"1");}catch{}
        setViewedHistory([...server,...missing].sort((a,b)=>b.ts-a.ts).slice(0,20));
      }catch(_){}
    })();
  },[me?.id]);
  useEffect(()=>{if(me)try{localStorage.setItem(`lanac:viewed:${me.id}`,JSON.stringify(viewedHistory));}catch(e){}},[viewedHistory,me?.id]); // try/catch 28/08 : quota plein ⇒ pas d'écran d'erreur persistant
  return {view,setView,viewRef,viewedHistory,setViewedHistory};
}
export { useNav };
